export default __webpack_public_path__ + "static/image1-a802488185fb5a24d8dcc98bf01bea6c.jpeg";